export default __webpack_public_path__ + "static/top-b3825a728dd9f63fc7392340d00c3c9f.png";